export default {
    name: "SideHeader",
    setup(){
        
    }
}